/**
 * Constantes globais do Octa Pontos. Tudo que e por-tenant fica em tab_tenants.
 * Aqui ficam apenas constantes verdadeiramente globais.
 */

export const APP_NAME = 'Octa Pontos';
export const APP_BUNDLE_ID = 'br.com.octapontos.app';

export const DEEP_LINK_SCHEME = 'octapontos';

/** Subdominio do super-admin (suporte cross-tenant). */
export const SUPER_ADMIN_SUBDOMAIN = 'admin';

/** Headers customizados usados pela aplicacao. */
export const HEADERS = {
  TENANT_CODE: 'x-tenant-code',
  REQUEST_ID: 'x-request-id',
} as const;

/** Finalidades LGPD para tab_consentimentos. */
export const FINALIDADES_LGPD = {
  ESSENCIAL: 'ESSENCIAL',
  MARKETING: 'MARKETING',
  GEOLOCALIZACAO: 'GEOLOCALIZACAO',
  PUSH: 'PUSH',
  ANALYTICS: 'ANALYTICS',
} as const;

export type FinalidadeLgpd = (typeof FINALIDADES_LGPD)[keyof typeof FINALIDADES_LGPD];

/** Buckets de storage do Supabase. */
export const STORAGE_BUCKETS = {
  CRLV: 'crlv-encrypted',
  EVIDENCIAS_LAVAGEM: 'evidencias-lavagem',
  TENANTS_ASSETS: 'tenants-assets',
  RELATORIOS: 'relatorios',
} as const;
